export function formatLocal(timestamp) {
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) {
    return 'Unknown';
  }
  return date.toLocaleString();
}

export function formatIsoDate(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return date.toISOString();
}

export function formatDisplayDate(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return 'Unknown';
  }
  return date.toLocaleDateString('nb-NO');
}

export function formatCoordinate(value) {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return '—';
  }
  return value.toFixed(6);
}

export function isValidCoordinate(value) {
  return typeof value === 'number' && Number.isFinite(value);
}

export function normaliseTenant(value) {
  if (!value) return '';
  return String(value).toLowerCase();
}
